"use client"

import { useState } from "react"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"

export function ContactFormIsland({ submitLabel = "Send message" }: { submitLabel?: string }) {
  const [submitted, setSubmitted] = useState(false)

  return (
    <form className="grid gap-4 rounded-[2rem] border border-border/70 bg-card p-6 shadow-sm" onSubmit={(event) => { event.preventDefault(); setSubmitted(true) }}>
      <div className="grid gap-2">
        <Label htmlFor="contact-name">Name</Label>
        <Input id="contact-name" name="name" autoComplete="name" required />
      </div>
      <div className="grid gap-2">
        <Label htmlFor="contact-email">Email</Label>
        <Input id="contact-email" name="email" type="email" autoComplete="email" required />
      </div>
      <div className="grid gap-2">
        <Label htmlFor="contact-message">Message</Label>
        <Textarea id="contact-message" name="message" rows={5} required />
      </div>
      <Button type="submit" className="rounded-full">{submitLabel}</Button>
      {submitted && <p className="text-sm text-muted-foreground" role="status">Thanks. Wire this form to your preferred action endpoint.</p>}
    </form>
  )
}